import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { withUserType } from '../withUserType';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { Layout } from 'antd';
import SubnavTabs from '../subnav_tabs/SubnavTabs';

const { Content } = Layout;

const AdminCycleEventsPage: React.FC<any> = ({
	childRoutes,
	userType,
	companyConfig,
}): React.ReactElement => {
	return (
		<div>
			<Route
				path={`/${userType}/workflows/cycleevents`}
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: `/${userType}/workflows/cycleevents/overview`,
						}}
					/>
				)}
			/>
			<Content className="projectsPage" style={{ padding: '0 0.5em' }}>
				<div
					style={{
						margin: '0 -8px',
						padding: '24px',
						paddingBottom: 0,
						background: nullSafeGet('detail.config.theme.navblock', companyConfig),
						marginBottom: 8,
					}}
				>
					<div
						style={{
							marginBottom: 24,
						}}
					>
						<h4
							style={{
								color: 'rgba(255, 255, 255, 0.9)',
								marginRight: 8,
								marginBottom: 0,
							}}
						>
							Asset Cycle Count
						</h4>
					</div>
					<SubnavTabs tabs={[]} onChange={() => {}} isActive={() => {}} />
				</div>
				{childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</Content>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	currentUser: state.session.currentUser,
});

export default withUserType(connect(mapStateToProps)(AdminCycleEventsPage as any) as any);
